<template>
	<section class="image-card" :style="{ maxWidth: cardWidth + 'px' }">
		<button class="image-card-button" @click="$emit('select', item)">
			<div class="image-card-image-wrapper">
				<img :src="imageURL" :alt="imgAltText" :style="imageStyles" />
			</div>
		</button>
		<h2 v-if="title">{{ title }}</h2>
		<p v-if="description">
			{{ description }}
			<span class="drip-enabled-tag-wrapper">
				<span class="drip-campaign-indicator" v-if="isActive"> Enabled </span>
			</span>
		</p>
	</section>
</template>

<script>
export default {
	name: 'ImageCard',
	props: {
		item: [String, Object, Array, Number],
		title: String,
		description: String,
		isActive: Boolean,
		cardWidth: Number,
		imageURL: String,
		imageHeight: Number,
	},
	computed: {
		imgAltText() {
			return this.title ? this.title : 'image';
		},
		imageStyles() {
			return {
				maxWidth: `${this.cardWidth}px`,
				maxHeight: `${this.imageHeight}px`,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.image-card {
	height: 100%;
	position: relative;
	box-sizing: border-box;
	border: 2px solid transparent;
	transform: scale(1);
	transition: all $b360-motion-duration--long $b360-motion-easing--accelerate;

	&:hover {
		transform: scale(1.02);
	}

	@include mobile {
		@include rem(margin-right, 25px);
		margin-left: unset;
	}

	.image-card-button {
		margin: 0;
		padding: 0;
		border: none;
		background: none;
		cursor: pointer;
	}

	.image-card-image-wrapper {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		border-radius: $border-radius;
		line-height: 0;
		background-color: $white;
		overflow: hidden;

		img {
			margin: 0;
			width: 100%;
			object-fit: cover;
		}
	}

	h2 {
		@include rem(margin, 10px 0);
		@include typo--roboto__medium;
		@include rem(font-size, 17px);
		@include rem(line-height, 17px);
	}

	p {
		@include rem(padding, 0 0 10px 0);
		@include typo--roboto__regular;
		@include rem(font-size, 15px);
		color: $b360-color--gray__darkest;
	}

	.drip-enabled-tag-wrapper {
		@include rem(margin-top, 10px);
		display: block;
	}

	.drip-campaign-indicator {
		@include rem('font-size', 13px);
		@include rem('padding', 4px 6px);
		box-sizing: border-box;
		border-radius: 6px;
		width: fit-content;
		height: fit-content;
		border: 1px solid $brand-teal;
		line-height: 1;
		font-weight: bold;
		color: $brand-teal;
		background: rgba($brand-teal, 0.05);
	}
}
</style>
